// import { experimentDebugger, emitter } from '@marvelapp/react-ab-test';

const setToDataLayer = function() {
  window.dataLayer.push(arguments);
};

// const implementExperiment = (experimentName, value) => {
//   console.log(`Experiment: ${experimentName}, Set value ${value}`);
//   emitter.setActiveVariant(experimentName, value);
// };

// export const initOptimizeExperiment = (
//   experimentName,
//   variants = ['0', '1'],
//   defaultVariant = '0',
// ) => {
//   if (process.env.BROWSER && window.App && window.App.optimize && !window.App.optimize.debug) {
//     const experiment = window.App.optimize.experiments.find(e => e.name === experimentName);
//     if (experiment && experiment.id) {
//       setTimeout(() => {
//         setToDataLayer('event', 'optimize.callback', {
//           name: experiment.id,
//           callback: value => {
//             implementExperiment(experimentName, value);
//           },
//         });
//       }, 1);
//     }
//   } else {
//     experimentDebugger.enable();
//   }

//   emitter.defineVariants(experimentName, variants);
//   emitter.setActiveVariant(experimentName, defaultVariant);
// };

export const initOptimizeExperiment = (experimentName, callback = () => {}) => {
  if (process.env.BROWSER && window.App && window.App.optimize && !window.App.optimize.debug) {
    const experiment = window.App.optimize.experiments.find(e => e.name === experimentName);
    if (experiment && experiment.id) {
      setTimeout(() => {
        setToDataLayer('event', 'optimize.callback', {
          name: experiment.id,
          callback,
        });
      }, 1);
    }
  } else {
    callback('0');
  }
};



// WEBPACK FOOTER //
// ./src/shared/helpers/abtesting.js